import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { KioskStateService } from '../services/kiosk-state.service';

@Injectable()
export class KioskLoginGuard implements CanActivate {

  constructor(
    private kioskStateService: KioskStateService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.kioskStateService.isBookingRegistrationAvailable) {
      this.router.navigate(['kiosk']);
      return false;
    }

    return true;
  }
}
